import { useState, useEffect } from "react";

const useAspectRatioWithPercentage = ({
  basePercentage,
  isWidth = true,
  parentRef,
}) => {
  const [dimension, setDimension] = useState(0);

  useEffect(() => {
    const calculateDimension = () => {
      if (parentRef) {
        const parentSize = isWidth
          ? parentRef.offsetWidth
          : parentRef.offsetHeight;
        const baseValue = (parentSize * basePercentage) / 100;

        // Calculate the corresponding dimension
        if (isWidth) {
          setDimension((baseValue * 9) / 16); // Height from width
        } else {
          setDimension((baseValue * 16) / 9); // Width from height
        }
      }
    };

    calculateDimension();

    // Recalculate on window resize
    window.addEventListener("resize", calculateDimension);
    return () => window.removeEventListener("resize", calculateDimension);
  }, [basePercentage, isWidth, parentRef]);

  return dimension;
};

export default useAspectRatioWithPercentage;
